<template>
    <div class="main-data">
        <v-form
            ref="form"
            v-model="valid"
            v-if="step === 1"
        >
            <v-card class=" px-10 px-md-16 py-10 white-color border-transparent" outlined>
                <v-row
                    v-for="(item, idx) in Number(calculations)"
                    :key="idx"
                    style="position: relative"
                >
                    <v-col
                        cols="12"
                        md="4"
                    >
                        <v-select
                            :items="cultures"
                            :value="getCultureId(idx)"
                            class="pt-0"
                            color="grey"
                            item-color="grey"
                            item-text="cultureName"
                            item-value="id"
                            :label="$t('culture')"
                            type="number"
                            :rules="rules"
                            @change="setCultureId($event, idx)"
                        ></v-select>
                    </v-col>
                    <v-col
                        cols="12"
                        md="4"
                    >
                        <v-text-field
                            :value="getHectaresCnt(idx)"
                            :label="$t('numberOfHectares')"
                            class="pt-0"
                            color="grey"
                            type="number"
                            min="0"
                            :rules="rules"
                            @change="setHectaresCnt($event, idx)"
                        ></v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        md="3"
                    >
                        <v-text-field
                            :value="getTreatmentsCnt(idx)"
                            class="pt-0"
                            color="grey"
                            type="number"
                            min="1"
                            :label="$t('numberOfTreatments')"
                            :rules="rules"
                            @change="setTreatmentsCnt($event, idx)"
                        ></v-text-field>
                    </v-col>
                    <v-btn
                        class="remove-btn"
                        icon
                        v-if="idx > 0"
                        @click="deleteCulture(idx)"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-row>
                <div class="d-flex justify-center mt-10">
                    <v-btn
                        :disabled="calculations.length < 1"
                        text
                        class="yellow--text text--darken-2"
                        @click="addCulture"
                    ><v-icon>mdi-plus</v-icon>&nbsp;{{$t('addCulture')}}</v-btn>
                </div>
            </v-card>
            <div class="d-flex justify-center mt-10">
                <v-btn
                    depressed
                    class="caption  white--text main--yellow"
                    width="130"
                    :disabled="!valid"
                    @click="validate"
                >{{$t('next')}}</v-btn>
            </div>
        </v-form>
    </div>
</template>

<script>
import CalculatorDataProvider from "../../../../app-front/mixins/CalculatorDataProvider";

export default {
    name: "MainDataStep",
    mixins: [ CalculatorDataProvider ],
    props: [ 'step', 'cultures' ],
    data() {
        return {
            valid: false,
            rules: [value => !!value || this.$t('requiredField')],
        }
    },
    computed: {
        calculations() {
            return this.$store.getters.calculatorFullData.length;
        }
    },
    methods: {
        addCulture() {
            this.setDefaultItem();
        },
        deleteCulture(idx) {
            this.deleteCalculation(idx)
        },
        validate() {
            if (this.$refs.form.validate()) {
                this.$emit('next-step')
            }
        },
    },
}
</script>

<style scoped>
    @media screen and (min-width: 1900px) {
        .main-data {
            margin-left: 100px !important;
            margin-right: 100px !important;
        }
    }
    .remove-btn {
        position: absolute;
        width: 45px;
        top: 5px;
        right: 5px;
        z-index: 1;
    }
</style>
